import { useDispatch, useSelector } from "react-redux";
import {
  changeConfirmationDialogState,
  displayInvoiceList,
  displayMainUtilityView,
  selectUtilityState,
} from "../../../../../features/utilities/utilitySlice";
import {
  selectBasicAccountState,
  setShouldBasicAccountPaymentRun,
  setTransactionIdToCancel,
} from "../../../../../features/basicAccount/basicAccountSlice";
import { selectGlobalDataState } from "../../../../../features/global/globalDataSlice";
import { selectUserInfo } from "../../../../../features/userInfo/userInfoSlice";
import { determineTransactionRequest } from "../DetermineTransactionRequest";
import { Button, Divider, Grid, Typography } from "@mui/material";
import colors from "../../../../colors";
import { texts } from "../../../../general/texts";
import { sendGeneralRequest } from "../../../../../features/generalRequest";
import { runBasicAccountPayment } from "../../../../general/BasicAccountMethods";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ConfirmationDialog from "../../../../general/ConfirmationDialog";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
const SiguracioneSingleExpandedInvoice = (props) => {
  const utilitySliceState = useSelector(selectUtilityState);
  const basicAccountSliceState = useSelector(selectBasicAccountState);
  const globalDataSliceState = useSelector(selectGlobalDataState);
  const userInfoSliceState = useSelector(selectUserInfo);
  const dispatch = useDispatch();
  const state = props.invoice; //?
  const transactionRequest = determineTransactionRequest(
    props.utilityName,
    globalDataSliceState.token,
    props.invoice,
    utilitySliceState
  );
  const location = useLocation();
  const handleButtonClick = () => {
    if (userInfoSliceState.accountType === 3) {
      // dispatch(setShouldBasicAccountPaymentRun(true))
      dispatch(
        sendGeneralRequest({
          request: {
            token: globalDataSliceState.token,
            paymentMethod: "2",
            applicationID: 1,
            value: utilitySliceState.singleInvoice["Vlera totale"].replace(
              /[^.\d]/g,
              ""
            ),
            transID: utilitySliceState.transactionId,
          },
          baseUrlKey: "services",
          endpoint: "startCreditCardPayment",
        })
      );
      dispatch(setTransactionIdToCancel(utilitySliceState.transactionId));
    } else {
      dispatch(changeConfirmationDialogState());
    }
  };

  const handleInvoiceBackButtonClick = () => {
    utilitySliceState.sentFrom === "contractList"
      ? dispatch(displayInvoiceList())
      : dispatch(displayMainUtilityView());
  };

  const handleConfirmation = () => {
    dispatch(
      sendGeneralRequest({
        request: {
          token: globalDataSliceState.token,
          transID: utilitySliceState.transactionId,
          service: utilitySliceState.extraData.service,
          passkey: utilitySliceState.pin, 
          passkeyType: 1, 
          comeFromWeb: true
        },
        baseUrlKey: "services",
        endpoint: "ConfirmTransactionSHU",
      })
    );
  };

  useEffect(() => {
    const handleLocationChange = () => {
        dispatch(setShouldBasicAccountPaymentRun(false));
    };

    handleLocationChange(); // Initial call to handle location on mount

    return () => {
        handleLocationChange(); // Call on unmount
    };
}, [location, dispatch]);

  const onBack = () => {
    dispatch(setShouldBasicAccountPaymentRun(false));
  };
  return (
    <Grid container justifyContent={"center"} pt={2}>
      {basicAccountSliceState.shouldBasicAccountPaymentRun ? (
        runBasicAccountPayment(
          dispatch,
          basicAccountSliceState.basicAccountPaymentUrl,
          {
            request: {
              token: globalDataSliceState.token,
              transID: utilitySliceState.transactionId,
              service: utilitySliceState.extraData.service,
              passkey: utilitySliceState.pin, 
              passkeyType: 1, 
              comeFromWeb: true
            },
            baseUrlKey: "services",
            endpoint: "ConfirmTransactionSHU", 
          },
          {
            request: {
              token: globalDataSliceState.token,
              orderId: utilitySliceState.transactionId,
            },
            baseUrlKey: "services",
            endpoint: "cancelCreditCardPayment",
          },
          onBack
        )
      ) : (
        <>
          <Grid container pb={"3%"}>
            <Grid item md={2} xs={2} pt={"1%"}>
              <Button
                onClick={handleInvoiceBackButtonClick}
                sx={{
                  height: "4rem",
                  borderRadius: "100%",
                  ":hover": { background: colors.white },
                }}
              >
                <ArrowBackIosNewIcon color="warning" />
              </Button>
            </Grid>
          </Grid>
          <Grid container justifyContent={"center"} p={3}>
            <Grid container md={12} pb={"10%"} item>
              <Divider
                sx={{
                  width: "100%",
                  marginBottom: "5%",
                  borderStyle: "dashed",
                }}
              />
              {Object.entries(state).map(([key, value]) => {
                return (
                  <>
                    {key === "Vlera totale" && (
                      <Divider
                        sx={{
                          width: "100%",
                          marginBottom: "5%",
                          borderStyle: "dashed",
                        }}
                      />
                    )}
                    <Grid container item md={12} xs={12} pb={4}>
                      <Grid container item justifyContent="flex-start" md={6}>
                        <Typography
                          style={{
                            color: colors.darkBlue,
                            fontFamily: "GerberaBold",
                            fontSize: "1.9vh",
                          }}
                        >
                          {key}
                        </Typography>
                      </Grid>
                      <Grid container item justifyContent="flex-end" md={6}>
                        <Typography
                          style={{
                            color:
                              key === "Vlera totale"
                                ? colors.orange
                                : colors.gray,
                            fontSize: "1.8vh",
                            fontFamily: "GerberaLight",
                          }}
                        >
                          {value}
                        </Typography>
                      </Grid>
                    </Grid>
                  </>
                );
              })}
            </Grid>
            <Grid container item justifyContent={"center"} pb={"2%"} md={12}>
              <Button
                disabled={utilitySliceState.isLoading ? true : false}
                style={{
                  background: colors.gradientOrange,
                  width: "100%",
                  color: colors.white,
                  textTransform: "none",
                  fontFamily: "GerberaBold",
                }}
                onClick={handleButtonClick}
              >
                {texts["title-pay"]}
              </Button>
            </Grid>
          </Grid>
          {utilitySliceState.isConfirmationDialogOpen && (
            <ConfirmationDialog
              handleClose={() => {
                dispatch(changeConfirmationDialogState());
              }}
              isConfirmationDialogOpen={
                utilitySliceState.isConfirmationDialogOpen
              }
              data={texts["message-confirm-transaction-general"]}
              handleConfirmationClick={handleConfirmation}
            />
          )}
        </>
      )}
    </Grid>
  );
};

export default SiguracioneSingleExpandedInvoice;
